import request from 'axios';
import { getClientAuthHeader } from '../../client/token';

export const intakeFormSaveAction = (data) => {
    return {
        types: ['INTAKE_FORM_SAVE_REQUEST', 'INTAKE_FORM_SAVE_SUCCESS', 'INTAKE_FORM_SAVE_FAILURE'],
        promise: request.put('/api/v1/forms/intake', data, getClientAuthHeader())
    };
};

export const contactFormSaveAction = (data) => {
    return {
        types: ['CONTACT_FORM_SAVE_REQUEST', 'CONTACT_FORM_SAVE_SUCCESS', 'CONTACT_FORM_SAVE_FAILURE'],
        promise: request.put('/api/v1/forms/client', data, getClientAuthHeader())
    };
};

export const contactsImportAction = (data) => {
    return {
        types: ['CONTACTS_IMPORT_REQUEST', 'CONTACTS_IMPORT_SUCCESS', 'CONTACTS_IMPORT_FAILURE'],
        promise: request.put('/api/v1/import/contacts', data, getClientAuthHeader())
    };
};

export const casesImportAction = (data) => {
    return {
        types: ['CASES_IMPORT_REQUEST', 'CASES_IMPORT_SUCCESS', 'CASES_IMPORT_FAILURE'],
        promise: request.put('/api/v1/import/cases', data, getClientAuthHeader())
    };
};

export const matterPartialFormSaveAction = (matter) => {
    return {
        types: ['PARTIAL_MATTER_FORM_SAVE_REQUEST', 'PARTIAL_MATTER_FORM_SAVE_SUCCESS', 'PARTIAL_MATTER_FORM_SAVE_FAILURE'],
        promise: request.put('/api/v1/forms/case', matter, getClientAuthHeader())
    };
};